import axios from '@/utils/request'
var Qs = require('qs')

export default {
	in_types: ['arrive', 'returnBack', 'check', 'allocate', 'other', 'cash', 'restore'],
	out_types: ['give', 'check', 'allocate', 'returnedMaterial', 'other', 'cash'],

	in_types_no_cash: ['arrive', 'returnBack', 'check', 'allocate', 'other'],
	out_types_no_cash: ['give', 'check', 'allocate', 'returnedMaterial', 'other'],
	// 2021-01-05
	search(params) {
		return axios.get('/mms/stock-in-outs', params)
	},
	// 2021-01-05
	exportExcel(params) {
		return axios.get('/mms/stock-in-outs/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-01-05
	batchPrint(params) {
		return axios.put('/mms/stock-in-outs/batch-print', params)
	},
	// 2022-01-03
	findCashByInventoryId(id) {
		return axios.get('/mms/stock-in-outs/find-cash-by-inventory-id/' + id)
	},
	// 2022-01-03
	findInventoryByInventoryId(id) {
		return axios.get('/mms/stock-in-outs/find-inventory-by-inventory-id/' + id)
	}
}

